import {
  SAVE_TEST_PROGRESS_REQUEST,
  SAVE_TEST_PROGRESS_SUCCESS,
  SAVE_TEST_PROGRESS_FAILURE,
  FETCH_TESTS_REQUEST,
  FETCH_TESTS_SUCCESS,
  FETCH_TESTS_FAILURE,
  FETCH_TEST_REQUEST,
  FETCH_TEST_SUCCESS,
  FETCH_TEST_FAILURE,
  DELETE_TEST_REQUEST,
  DELETE_TEST_SUCCESS,
  DELETE_TEST_FAILURE,
  UPDATE_TEST_REQUEST,
  UPDATE_TEST_SUCCESS,
  UPDATE_TEST_FAILURE,
  FETCH_USER_ANSWER_HISTORY_REQUEST,
  FETCH_USER_ANSWER_HISTORY_SUCCESS,
  FETCH_MISSED_QUESTIONS_REQUEST,
  FETCH_MISSED_QUESTIONS_SUCCESS,
  FETCH_MISSED_QUESTIONS_FAILURE,
  FETCH_USER_ANSWER_HISTORY_FAILURE,
  FETCH_USER_PERFORMANCE_REQUEST,
  FETCH_USER_PERFORMANCE_SUCCESS,
  FETCH_USER_PERFORMANCE_FAILURE,
  FETCH_PEER_DISTRIBUTION_REQUEST,
  FETCH_PEER_DISTRIBUTION_SUCCESS,
  FETCH_PEER_DISTRIBUTION_FAILURE,
  CLEAR_CURRENT_TEST,
  RESET_TEST_PROGRESS
} from './TestProgressTypes';

const initialState = {
  tests: [],
  currentTest: null,
  userAnswerHistory: {},
  missedQuestions: {},
  missedSpecialty: null,
  missedLoading: false,
  missedError: null,
  missedLoaded: false,
  userPerformance: null,
  peerDistribution: null,
  loading: false,
  error: null,
  success: false,
  // H7: per-operation flags to prevent state bleed between concurrent operations
  saveLoading: false,
  fetchLoading: false,
  deleteLoading: false
};

export const testProgressReducer = (state = initialState, action) => {
  switch (action.type) {
    // H7: separate loading flags per operation to prevent state bleed
    case SAVE_TEST_PROGRESS_REQUEST:
      return {
        ...state,
        saveLoading: true,
        loading: true,
        error: null,
        success: false
      };

    case FETCH_TESTS_REQUEST:
    case FETCH_TEST_REQUEST:
    case FETCH_USER_ANSWER_HISTORY_REQUEST:
    case FETCH_USER_PERFORMANCE_REQUEST:
    case FETCH_PEER_DISTRIBUTION_REQUEST:
      return {
        ...state,
        fetchLoading: true,
        loading: true,
        error: null,
        success: false
      };

    case DELETE_TEST_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        loading: true,
        error: null,
        success: false
      };

    case UPDATE_TEST_REQUEST:
      return {
        ...state,
        saveLoading: true,
        loading: true,
        error: null,
        success: false
      };

    case SAVE_TEST_PROGRESS_SUCCESS:
      return {
        ...state,
        saveLoading: false,
        loading: state.fetchLoading || state.deleteLoading,
        // C3 fix: merge with existing currentTest to preserve fields not in the save payload
        currentTest: state.currentTest
          ? { ...state.currentTest, ...action.payload }
          : action.payload,
        success: true
      };

    case FETCH_TESTS_SUCCESS:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        tests: action.payload,
        success: true
      };

    case FETCH_TEST_SUCCESS:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        currentTest: action.payload,
        success: true
      };

    case DELETE_TEST_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        loading: state.saveLoading || state.fetchLoading,
        tests: state.tests.filter(test => test.testId !== action.payload),
        success: true
      };

    case UPDATE_TEST_SUCCESS:
      return {
        ...state,
        saveLoading: false,
        loading: state.fetchLoading || state.deleteLoading,
        currentTest: state.currentTest
          ? { ...state.currentTest, ...action.payload }
          : action.payload,
        tests: state.tests.map(test =>
          test.testId === action.payload.testId
            ? { ...test, ...action.payload }
            : test
        ),
        success: true
      };

    case CLEAR_CURRENT_TEST:
      return {
        ...state,
        currentTest: null
      };

    // Dedicated flags — deliberately does not touch loading/fetchLoading so the
    // missed-questions panel can load without affecting anything else on screen
    case FETCH_MISSED_QUESTIONS_REQUEST:
      return { ...state, missedLoading: true, missedError: null };

    case FETCH_MISSED_QUESTIONS_SUCCESS:
      return {
        ...state,
        missedLoading: false,
        missedQuestions: action.payload.missedQuestions,
        missedSpecialty: action.payload.specialty,
        missedLoaded: true,
        missedError: null
      };

    case FETCH_MISSED_QUESTIONS_FAILURE:
      return { ...state, missedLoading: false, missedError: action.payload };

    case FETCH_USER_ANSWER_HISTORY_SUCCESS:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        userAnswerHistory: action.payload,
        success: true
      };

    case FETCH_USER_PERFORMANCE_SUCCESS:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        userPerformance: action.payload,
        success: true
      };

    case FETCH_PEER_DISTRIBUTION_SUCCESS:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        peerDistribution: action.payload,
        success: true
      };

    case SAVE_TEST_PROGRESS_FAILURE:
      return {
        ...state,
        saveLoading: false,
        loading: state.fetchLoading || state.deleteLoading,
        error: action.payload,
        success: false
      };

    case DELETE_TEST_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        loading: state.saveLoading || state.fetchLoading,
        error: action.payload,
        success: false
      };

    case UPDATE_TEST_FAILURE:
      return {
        ...state,
        saveLoading: false,
        loading: state.fetchLoading || state.deleteLoading,
        error: action.payload,
        success: false
      };

    case FETCH_TESTS_FAILURE:
    case FETCH_TEST_FAILURE:
    case FETCH_USER_ANSWER_HISTORY_FAILURE:
    case FETCH_USER_PERFORMANCE_FAILURE:
    case FETCH_PEER_DISTRIBUTION_FAILURE:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        error: action.payload,
        success: false
      };

    case RESET_TEST_PROGRESS:
      return initialState;

    default:
      return state;
  }
};
